// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1uzCr","left":"StickyBox_left__2Ctmb","right":"StickyBox_right__1MnfK"};